/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_EmptyInputs */

const vi_confirm_return_empty = /** @type {(inputs: Confirm_Return_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn không có vật tư bao bì đã trừ.`)
};

/**

* @param {Confirm_Return_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_empty = /** @type {((inputs?: Confirm_Return_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_empty(inputs)
});